import { useState } from "react";
import { useIntl } from "react-intl";
import { OverlayTrigger, Tooltip } from "@rio-cloud/rio-uikit";

interface CopyButtonProps {
  textToCopy: string;
  className?: string;
}

const CopyButton = ({ textToCopy, className = "" }: CopyButtonProps) => {
  const intl = useIntl();
  const [showCopied, setShowCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(textToCopy);
      setShowCopied(true);
      setTimeout(() => setShowCopied(false), 2000); // Esconde o feedback após 2 segundos
    } catch (err) {
      console.error('Erro ao copiar para área de transferência:', err);
    }
  };

  const button = (
    <button
      type="button"
      onClick={handleCopy}
      className={`inline-flex items-center justify-center w-10 h-10 text-green-800 dark:text-green-300 hover:text-green-900 dark:hover:text-green-200 bg-green-50 dark:bg-green-900/30 hover:bg-green-100 dark:hover:bg-green-900/50 border border-gray-300 dark:border-neutral-600 rounded transition-colors duration-200 ${className}`}
      title={intl.formatMessage({ id: "intl-msg:kanban.form.copyButton.copyToClipboard" })}
    >
      <svg
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="w-5 h-5"
      >
        <path
          d="M16 1H4C2.9 1 2 1.9 2 3V17H4V3H16V1ZM19 5H8C6.9 5 6 5.9 6 7V21C6 22.1 6.9 23 8 23H19C20.1 23 21 22.1 21 21V7C21 5.9 20.1 5 19 5ZM19 21H8V7H19V21Z"
          fill="currentColor"
        />
      </svg>
    </button>
  );

  return (
    <OverlayTrigger
      placement="top"
      show={showCopied}
      onToggle={() => {}}
      overlay={<Tooltip id="copy-button-tooltip">{intl.formatMessage({ id: "intl-msg:kanban.form.copyButton.copied" })}</Tooltip>}
    >
      {button}
    </OverlayTrigger>
  );
};

export default CopyButton;
